import { useMemo, useState } from 'react';
import { NewTaskForm } from '../forms';
import { TasksFeed } from '../blocks/TasksFeed';
import { FilterToggle } from '../helpers/FilterToggle';

const sortTasksByDueDate = (tasks) => {
  return [...tasks].sort((a, b) => {
    if (!a.due_date && !b.due_date) return 0;
    if (!a.due_date) return 1;
    if (!b.due_date) return -1;
    return new Date(a.due_date) - new Date(b.due_date);
  });
};

export const TasksTable = ({ project }) => {
  const [showCompleted, setShowCompleted] = useState(false);

  const allTasks = useMemo(() => {
    return sortTasksByDueDate(project?.project_tasks || []);
  }, [project]);

  const hasCompletedTasks = useMemo(
    () => allTasks.some((task) => task.status === 'Completed'),
    [allTasks]
  );

  const tasks = useMemo(() => {
    if (showCompleted) return allTasks;
    return allTasks.filter((task) => task.status !== 'Completed');
  }, [allTasks, showCompleted]);

  const emptyMessage = showCompleted
    ? 'Tasks will appear as they are created for this project.'
    : 'No pending tasks for this project. Toggle "Include completed" to view finished tasks.';

  return (
    <div>
      <div className="designs-header">
        <div className="designs-header-main">
          <NewTaskForm project={project} />
        </div>
        {hasCompletedTasks && (
          <div className="designs-filters">
            <FilterToggle
              label="Include completed"
              checked={showCompleted}
              onChange={setShowCompleted}
            />
          </div>
        )}
      </div>
      <br />
      <TasksFeed
        tasks={tasks}
        project={project}
        showAssignee
        emptyTitle={showCompleted ? 'No tasks available.' : 'No pending tasks.'}
        emptyMessage={emptyMessage}
      />
    </div>
  );
};
